import axiosHttp from '../hooks/intercepter';
const BASE_URL = process.env.REACT_APP_BASE_URL;

const createSubscription = async (subscriptionData) => {
    return await axiosHttp.post(`${BASE_URL}/subscription`, subscriptionData);
};

export { createSubscription }; 